export default function sortParticipants(
  participants,
  current_user_id,
  alphabetical = true
) {
  const currentUserParticipant = participants.find((p) => p.isCurrentUser);

  if (currentUserParticipant) {
    for (var p of participants) {
      if (p.user_id == currentUserParticipant.user_id)
        p.isCurrentUserParticipant = true;
    }
  }
  participants.sort((x, y) => {
    // make sure that the current user is the first in the list
    if (x.isCurrentUser) {
      return -1;
    }
    if (y.isCurrentUser) {
      return 1;
    }

    if (current_user_id && x.user_id == current_user_id) {
      return -1;
    }

    // make sure that the current user participants are on the top of the list

    // if (x.isCurrentUserParticipant) {
    //   return -1;
    // }
    // if (y.isCurrentUserParticipant) {
    //   return 1;
    // }

    // keep the remaining users sorted by id
    // var x created = new Date(x.created_at);
    // var y created = new Date(y.created_at);
    // return y created - x created;

    if (!alphabetical) {
      console.log('Sorting is by date');
      var xcreated = new Date(x.created_at);
      var ycreated = new Date(y.created_at);
      return xcreated - ycreated;
    }
    const xname = x.name.trim().toLowerCase();
    const yname = y.name.trim().toLowerCase();
    // if (x.name < y.name) {
    //   return -1;
    // }
    // if (x.name > y.name) {
    //   return 1;
    // }
    // return 0;
    if (xname < yname) return -1;
    if (yname < xname) return 1;
    return 0;
  });
}
